const ILoggingServiceId = Symbol("ILoggingService");
interface ILoggingService {
    InitialiseAppInsights();
    StartPageViewTracking();
    EnableTrackingCookies();
    LogMessage(message: string);
    LogError(message: string);
    LogException(message: string);
};

export { ILoggingServiceId, ILoggingService }